import { put, call, takeLatest, select, take, delay } from "redux-saga/effects";
import { AsyncReturnType } from "type-fest";

//actions
import WeatherDataActions from "Containers/WeatherData/WeatherData.actions";

//database
import DatabaseDbs from "Containers/Database/Database.dbs";

//selectors
import { getWeatherDataIsLoading, getWeatherDataWeatherData } from "Containers/WeatherData/WeatherData.selectors";

//utils
import { fetchWeatherData } from "./WeatherData.utils";

function* onInitiate() {
	yield take((action: any) => action.type === "persist/REHYDRATE" && action.key === "root");
	yield put(WeatherDataActions.FETCH_WEATHER_DATA.request());
}

function* onUninitiate() {
	console.log("onUninitiate");
}

function* onFetchWeatherData() {
	yield put(WeatherDataActions.SET_IS_LOADING.action(true));
	try {
		let reachedEndOfList = false;
		let offSet = 0;
		while (true) {
			const isLoading: boolean = yield select(getWeatherDataIsLoading);
			const currentWeatherData: WeatherReduxType[] = yield select(getWeatherDataWeatherData);
			const { id: currentId } = currentWeatherData?.[0] || { id: null };
			const limit = offSet ? 50000 : 200;

			if (currentId) {
				if (reachedEndOfList) yield delay(15000);

				const response: AsyncReturnType<typeof fetchWeatherData> = yield call(fetchWeatherData, 999999, undefined, currentId);
				if ("error" in response) throw new Error(response.error);
				if (response.length > 0) {
					yield put(WeatherDataActions.SET_WEATHER_DATA.action(response));
					yield call(async () => await DatabaseDbs.WEATHERDATA.bulkPut(response));
				}
			}

			if (reachedEndOfList) continue;

			const response: AsyncReturnType<typeof fetchWeatherData> = yield call(fetchWeatherData, limit, offSet);
			if ("error" in response) throw new Error(response.error);
			if (response.length === 200) yield put(WeatherDataActions.SET_WEATHER_DATA.action(response));
			// const currentDataInDexie: WeatherReduxType[] = yield call(async () => await DatabaseDbs.WEATHERDATA.toArray());
			yield call(async () => await DatabaseDbs.WEATHERDATA.bulkPut(response));

			if (isLoading) yield put(WeatherDataActions.SET_IS_LOADING.action(false));

			if (response.length === 0) reachedEndOfList = true;
			offSet += limit;
		}
	} catch (error) {
		console.error(error);
	}
	yield put(WeatherDataActions.SET_IS_LOADING.action(false));
}

export default function* rootSagas() {
	yield takeLatest(WeatherDataActions.INITIATE.ACTION, onInitiate);
	yield takeLatest(WeatherDataActions.UNINITIATE.ACTION, onUninitiate);
	yield takeLatest(WeatherDataActions.FETCH_WEATHER_DATA.REQUEST, onFetchWeatherData);
}
